import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

type Props = {
  employeeName: string;
};
const ManagerViewEmployeeConsentGivenBanner = ({ employeeName }: Props) => (
  <BannerContainer themeColor={ThemeColorType.warning}>
    <Text14 themeColor={ThemeColorType.white} semiBold>
      {gettext('%(employeeName)s approved the timesheet edits.', { employeeName })}
    </Text14>

    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('Pending your approval.')}
      </Text14>
    </div>
  </BannerContainer>
);

export default ManagerViewEmployeeConsentGivenBanner;
